<template>
  <div
    class="vol"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
  >
    <div
      v-show="rangeVisible || isMoving"
      ref="track"
      class="range track"
      :draggable="false"
      @mousedown.stop.prevent="onClickTrack"
    >
      <div
        class="bar"
        :style="{ width: `${currentPos * 100}%` }"
        :draggable="false"
      ></div>
      <div
        class="thumb"
        :class="{ active: isMoving }"
        :style="{ left: `${currentPos * 100}%` }"
        :draggable="false"
        @mousedown.stop.prevent="startMove"
      ></div>
    </div>
    <div class="btn">
      <iconfont
        name="#icon11-13yinlianganniu"
        font-size="12px"
      ></iconfont>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      trackStart: 0,
      trackSize: 0,
      isMoving: false,
      rangeVisible: false
    };
  },
  computed: {
    currentPos() {
      let pos = ((this.value || 0) - this.min) / (this.max - this.min);
      return pos;
    }
  },
  watch: {},
  mounted() {
    this.initPos();
    window.addEventListener('resize', this.initPos);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.initPos);
  },
  methods: {
    mouseenter() {
      this.rangeVisible = true;
      this.$nextTick(() => {
        this.initPos();
      });
    },
    mouseleave() {
      this.rangeVisible = false;
    },
    initPos() {
      let rect = this.$refs.track.getBoundingClientRect();
      this.trackStart = rect.left;
      this.trackSize = rect.width;
    },
    startMove() {
      this.isMoving = true;
      this.$emit('startMove');
      window.addEventListener('mousemove', this.moving);
      window.addEventListener('mouseup', this.endMove);
    },
    moving(e) {
      this.updateValue(e.clientX);
    },
    endMove() {
      window.removeEventListener('mousemove', this.moving);
      window.removeEventListener('mouseup', this.endMove);
      this.isMoving = false;
      this.$emit('endMove');
    },
    updateValue(axis) {
      let progress = axis - this.trackStart;
      progress = progress / this.trackSize;
      progress = progress * (this.max - this.min);
      let value = progress;
      if (this.step) {
        value = Math.round(progress / this.step) * this.step;
        value = value.toFixed(0) - 0;
      }
      value = Math.max(Math.min(value, this.max), this.min);
      this.$emit('input', value);
    },
    onClickTrack(e) {
      this.startMove();
      this.updateValue(e.clientX);
    }
  }
};
</script>

<style lang="scss" scoped>
.vol {
  display: flex;
  align-items: center;
  justify-content: center;
  transition-duration: 0.3s;
  min-width: 24px;
  height: 24px;
  border-radius: 24px;
  &:hover {
    background-color: rgba(#000, 0.4);
  }
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  color: #fff;
}

$track-width: 2px;
.track {
  position: relative;
  width: 47px;
  height: $track-width;
  background-color: rgba(#fff, 0.5);
  border-radius: 5px;
  margin-left: 6px;
  margin-right: 6px;
}
.bar {
  width: 0;
  height: $track-width;
  background: #fff;
  border-radius: 5px;
}
.thumb {
  $thumb-width: 6px;
  $thumb-height: $thumb-width;

  position: absolute;
  top: 0;
  left: 0;
  margin-top: -($thumb-height - $track-width) / 2;
  margin-left: -$thumb-width / 2;
  width: $thumb-width;
  height: $thumb-height;
  background: #ffffff;
  box-shadow: 0px 5px 30px 0px rgba(22, 64, 234, 0.16);
  border-radius: 50%;
  user-select: none;
  cursor: grab;
  transition-property: transform;
  transition-duration: 0.3s;
  &.active,
  &:hover {
    transform: scale(1.2);
  }
}
</style>
